"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function checkFormat(jsonString) {
    let surface;
    try {
        surface = JSON.parse(jsonString);
    }
    catch (e) {
        throw new Error(`Couldn't parse JSON surface. ${e}`);
    }
    if (!Number.isFinite(surface.fps) || surface.fps <= 0) {
        throw new Error('Wrong FPS value');
    }
    if (!Number.isFinite(surface.width) || surface.width <= 0 || surface.width > 30) {
        throw new Error('Wrong width value');
    }
    if (!Number.isFinite(surface.height) || surface.height <= 0 || surface.height > 30) {
        throw new Error('Wrong height value');
    }
    if (!Number.isFinite(surface.low) ||
        !Number.isFinite(surface.high) ||
        surface.low >= surface.high) {
        throw new Error('Wrong low/high values');
    }
    if (!surface.frames || !surface.frames.length) {
        throw new Error('Missing frames data');
    }
    if (surface.frames[0].length !== surface.width * surface.height) {
        throw new Error("Frames length doesn't match");
    }
}
exports.default = checkFormat;
